import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import UseCases from "@/pages/UseCases";
import CustomerStories from "@/pages/CustomerStories";
import Contact from "@/pages/Contact";
import Trust from "@/pages/Trust";
import Manifesto from "@/pages/Manifesto";
import Admin from "@/pages/Admin";

function App() {
    useEffect(() => {
        // Cursor-follow spotlight on every .gleap-card
        const onMove = (e) => {
            const cards = document.querySelectorAll(".gleap-card");
            cards.forEach((card) => {
                const rect = card.getBoundingClientRect();
                if (
                    e.clientX >= rect.left &&
                    e.clientX <= rect.right &&
                    e.clientY >= rect.top &&
                    e.clientY <= rect.bottom
                ) {
                    card.style.setProperty("--mx", `${e.clientY - rect.top}px`);
                    card.style.setProperty("--my", `${e.clientX - rect.left}px`);
                }
            });
        };
        window.addEventListener("mousemove", onMove, { passive: true });
        return () => window.removeEventListener("mousemove", onMove);
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/solutions/:slug" element={<SolutionDetail />} />
                        <Route path="/use-cases" element={<UseCases />} />
                        <Route path="/customer-stories" element={<CustomerStories />} />
                        <Route path="/industries" element={<Navigate to="/use-cases" replace />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/platform" element={<Platform />} />
                        <Route path="/trust" element={<Trust />} />
                        <Route path="/manifesto" element={<Manifesto />} />
                        <Route path="/admin" element={<Admin />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
